//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { sysEnts_showTree } from '@/apis/system'
export default {
    data() {
        return {
            form:{
                sysType:'MGR'
            },
            //table loading
            loading: false,
            //table data
            data: [],
            //table columns
            columns: [],
        }
    },
    created() {
        this.columns = [
            { title: '權限ID', dataIndex: 'entId', key: 'entId', width: 330, },
            { title: '權限名稱', dataIndex: 'entName', key: 'entName', width: 330, },
            { title: '圖標', dataIndex: 'menuIcon', key: 'menuIcon', width: 330, scopedSlots: { customRender: 'menuIcon' }, },
            { title: '路徑', dataIndex: 'menuUri', key: 'menuUri', width: 220, },
            { title: '類型', dataIndex: 'entType', key: 'entType', width: 220, },
            { title: '狀態', dataIndex: 'state', key: 'state', width: 220, scopedSlots: { customRender: 'state' }, },
            { title: '排序', dataIndex: 'entSort', key: 'entSort', width: 220, },
            { title: '修改時間', dataIndex: 'updatedAt', key: 'updatedAt', width: 220, }
        ];
    },
    mounted() {
        this.$nextTick(async () => {
            await this.onPageLoad();
        });
    },
    methods: {
        async getSysEntsShowTree() {
            try {
                const res = await sysEnts_showTree(this.form.sysType) || {};
                if (res.code == 0) {
                    this.data = res.data;
                } else {
                    if (res.msg)
                        throw new Error(res.msg);
                }
            } catch (error) {

            }
        },
        async onPageLoad() {
            if (this.loading) return;
            try {
                this.loading = true;
                await this.getSysEntsShowTree();
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.loading = false;
            }
        },
        onSelectChange(){
            this.onPageLoad();
        }
    }
}
